const WORDS = ["ALL BETS ON YOU", "STRATEGY", "INTELLIGENCE", "COMPETITION", "RISK", "OPPORTUNITY", "AMBITION"];
const SUITS = ["♠", "♦", "♣", "♥"];

function Sequence() {
  return (
    <div className="flex shrink-0 items-center">
      {WORDS.map((word, i) => (
        <span key={word} className="flex items-center">
          <span className="font-bebas text-2xl sm:text-3xl tracking-[0.3em] text-[#F6F4EE]/80 px-8 whitespace-nowrap">
            {word}
          </span>
          <span className="text-[#D4AF37]/70 text-lg" aria-hidden="true">{SUITS[i % SUITS.length]}</span>
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-[#D4AF37]/15 bg-[#0B0B0F] py-5">
      <div className="flex w-max animate-marquee">
        <Sequence />
        <Sequence />
      </div>
    </div>
  );
}
